import {
  BuildOutlined,
  CalculatorOutlined,
  FileOutlined,
  FileTextOutlined,
  FilterOutlined,
  FolderOpenFilled,
  HighlightOutlined,
  MessageOutlined,
  ProfileOutlined,
  QuestionOutlined,
  SettingOutlined,
  TagOutlined,
} from "@ant-design/icons";
import { ConditionIcon, IconProps, TransformationIcon, TriggerIcon } from "@org-avp/avp-avengers-ui-shared-icons";
import { FC } from "react";
import { IconName } from "./iconName";

export interface IconDef extends IconProps {
  iconName: IconName;
}

interface IconContainerProps {
  className?: string;
  iconDefs: IconDef[];
}

export const IconContainer: FC<IconContainerProps> = ({ className, iconDefs }) => {
  return <div className={className}>{iconDefs.map((iconDef) => <IconItem key={iconDef.iconName} {...iconDef}/>)}</div>;
};

const IconItem: FC<IconDef> = ({ iconName, ...iconProps }) => {
  switch (iconName) {
    case IconName.BLANK:
      return <span role="img">&nbsp;</span>;
    case IconName.COMMENT:
      return <MessageOutlined {...iconProps}/>;
    case IconName.CONDITION:
      return <ConditionIcon {...iconProps}/>;
    case IconName.CONSTRUCTION_KIT:
      return <BuildOutlined {...iconProps}/>;
    case IconName.FILTER:
      return <FilterOutlined {...iconProps}/>;
    case IconName.MARKETING_RULE:
      return <CalculatorOutlined {...iconProps}/>;
    case IconName.MARK_1:
      return <HighlightOutlined {...iconProps}/>;
    case IconName.MARK_2:
      return <HighlightOutlined {...iconProps}/>;
    case IconName.MASTER_SHEET:
      return <FileOutlined {...iconProps}/>;
    case IconName.TAG:
      return <TagOutlined {...iconProps}/>;
    case IconName.TRANSFORMATION:
      return <TransformationIcon {...iconProps}/>;
    case IconName.TRIGGER:
      return <TriggerIcon {...iconProps}/>;
    case IconName.FOLDER:
      return <FolderOpenFilled {...iconProps}/>;
    case IconName.GEOMETRY:
      return <SettingOutlined {...iconProps}/>;
    case IconName.PARTLIST_ENTRY:
      return <ProfileOutlined {...iconProps}/>;
    case IconName.PART:
      return <FileTextOutlined {...iconProps}/>;
    case IconName.UNKNOWN:
      return <QuestionOutlined {...iconProps}/>;
  }
};
